import EfScrollAni from '@/efscrollani';
import { useProductStore } from '../../ProductStationProvider';
import { IPageStatus } from '../../config/IPageStatus';
import getLocal from '@/app/utils/i18n';
import StatusA from './StatusA';

export default function ExampleProductA() {
    const { pageStatus } = useProductStore();
    const { locale } = getLocal();

    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    return <div className="page-product">{['us', 'ca'].includes(locale) && <>{pageStatus === IPageStatus.statusA && <StatusA />}</>}</div>;
}
